import type Article from "models/Article";
import type Commande from "models/Commande";
import type CommandeArticle from "models/CommandeArticle";

function isLimitExceeded(
  commandeHistory: Array<CommandeArticle>,
  article: Article,
  quantite: number
): boolean {
  if (
    article?.quantiteMaxParPeriode !== undefined &&
    Number.isInteger(article.quantiteMaxParPeriode) &&
    article.quantiteMaxParPeriode > 0 &&
    article?.quantiteMaxPeriode !== undefined &&
    Number.isInteger(article.quantiteMaxPeriode) &&
    article.quantiteMaxPeriode > 0
  ) {
    const now = new Date();
    const periodStart = new Date(now);
    periodStart.setMonth(now.getMonth() - article.quantiteMaxPeriode);
    const orderedByPeriod = commandeHistory
      .filter(
        (h) =>
          h.articleId === article.id &&
          h.statutArticle !== "REFUSE" &&
          h.statutArticle !== "ANNULE" &&
          new Date(h.dateCommande) >= periodStart
      )
      .reduce((sum, h) => sum + h.quantite, 0);
    const totalWithCart = orderedByPeriod + quantite;
    return totalWithCart > article.quantiteMaxParPeriode;
  }
  return false;
}

function getUniquesNumerosBonDeCommandeFromCommandes(commandes: Array<Commande>): Array<string> {
  return getUniquesNumerosBonDeCommande(commandes.flatMap((c) => c.articles));
}

function getUniquesNumerosBonDeCommande(commandeArticles: Array<CommandeArticle>): Array<string> {
  const allNumeroBonDeCommande = [
    ...commandeArticles.reduce((acc, ca) => {
      if (ca.numeroBonDeCommande != null && ca.numeroBonDeCommande.trim() !== "") {
        acc.add(ca.numeroBonDeCommande);
      }
      return acc;
    }, new Set<string>()),
  ];
  return allNumeroBonDeCommande.toSorted((a, b) => a.localeCompare(b));
}

const commandeArticleUtil = {
  getUniquesNumerosBonDeCommandeFromCommandes,
  getUniquesNumerosBonDeCommande,
  isLimitExceeded,
};

export default commandeArticleUtil;
